import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import { Field, useFormikContext } from 'formik';

import MultiOptionField from 'components/MultiOptionField';
import { IExpandedMailingRule } from 'interfaces/MailingRule';
import { RootState } from 'store';

import { IMailingRuleSubformProps } from '../../interfaces';

import SubFormKeyRanges from './SubFormKeyRanges';
import SubFormMultipleSelections from './SubFormMultipleSelections';
import SubFormExclusionsAndSelections from './SubFormExclusionsAndSelections';
import SubFormCountAndSumRanges from './SubFormCountAndSumRanges';

const Form: React.FC<IMailingRuleSubformProps> = ({
  isEditable,
}: IMailingRuleSubformProps) => {
  const { current } = useSelector((state: RootState) => state.mailingRule);
  const { parameters } = useSelector((state: RootState) => state);
  const {
    list: { mailingRuleAggregationTypes },
  } = useSelector((state: RootState) => state.parameters);

  const {
    values,
    setFieldValue,
    setValues,
  } = useFormikContext<IExpandedMailingRule>();

  useEffect(() => {
    if (current) {
      setValues(current);
    }
  }, [current, setValues]);

  useEffect(() => {
    if (values.aggregationType === 'CONTRACT') {
      setFieldValue('customerAging.min', 0);
      setFieldValue('customerAging.max', 0);
      setFieldValue('customerDebtsSum.min', 0);
      setFieldValue('customerDebtsSum.max', 0);
      setFieldValue('customerContractsSum.min', 0);
      setFieldValue('customerContractsSum.max', 0);
    }
  }, [values.aggregationType, setFieldValue]);

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="stretch"
      spacing={1}
    >
      <Grid
        item
        xs={12}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Typography variant="h6">Tipo de atuação</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          data-cy="general-rules-form__radio-buttons--service-category"
        >
          {parameters.loading === 'succeeded' && (
            <MultiOptionField
              name="serviceCategory"
              options={parameters.list.serviceCategories.map((item) => ({
                value: item._id,
                label: item.description,
              }))}
              singleSelection
              disabled={!isEditable}
              onChange={() => setFieldValue('selectedEPS', {})}
            />
          )}
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Field
          data-cy="general-rules-form__input--name"
          fullWidth
          component={TextField}
          name="name"
          label="Nome da Régua de Mailing"
          disabled={!isEditable}
        />
      </Grid>

      <Grid
        data-cy="general-rules-form__container--aggregation-type"
        item
        xs={12}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Typography variant="h6">Chave de distribuição</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          data-cy="general-rules-form__radio-buttons--aggregation-type"
        >
          <MultiOptionField
            name="aggregationType"
            options={mailingRuleAggregationTypes}
            singleSelection
            disabled={!isEditable}
          />
        </Grid>
      </Grid>

      <SubFormKeyRanges isEditable={isEditable} />
      <SubFormMultipleSelections isEditable={isEditable} />
      <SubFormExclusionsAndSelections isEditable={isEditable} />

      <SubFormCountAndSumRanges isEditable={isEditable} />
    </Grid>
  );
};

export default Form;
